import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { HttpClientBaseService } from './base/httpClientBase.service';
import { Injectable } from '@angular/core';
import { Observable, forkJoin, from, of, throwError } from 'rxjs';
import { AppAttendanceTypes } from '../models/appAttendanceTypes.model';

import { IServiceBase } from './base/IServiceBase';
import { PageList } from '../models/pageList.model';
import { AppConfig } from '../configuration/app.config';
import { catchError, map, switchMap } from 'rxjs/operators';
import { LivesSessionHelper } from '../helper/livesSessionHelper';

//usuarios copy ARREGLAR (son los métodos de get y set)

@Injectable({ providedIn: 'root' })
export class AppAttendanceTypesService extends HttpClientBaseService implements IServiceBase<AppAttendanceTypes> {



  constructor(
    _http: HttpClient,
    private _livesSession: LivesSessionHelper,
  ) {
    super(_http, '/attendanceTypes/', '', false);


  }

  getPagedModels(parentId?: any, params?: HttpParams): Observable<PageList<AppAttendanceTypes>> {
    throw new Error('Method not implemented.');
  }

  public getModel(id: any): any {
  }

  getAllModels(companyId?: any, params?: HttpParams): Observable<any> {
    const justEnabled = params?.get('enabled') === 'true';

    let url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/types?company=${companyId}`;
    if (justEnabled) {
      url += `&enabled=true`;
    }
    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });
    return this.http.get<any>(url, { headers: headers });
  }

  public createModel(data: Partial<AppAttendanceTypes>): Observable<AppAttendanceTypes> {
    const environmentId = this._livesSession.EnvironmentId;
    if (!environmentId) {
      return throwError(new Error("No environment ID found in session storage"));
    }

    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/type`;

    const body = {
      "name": data.name,
      "company": data.companyId,
      "environment": environmentId,
      "enabled": data.enabled,
      "entry": data.entry,
      "imputable": data.imputable
    }

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.post<any>(url, body, { headers: headers });
  }

  public updateModel(id: string, data: any): Observable<AppAttendanceTypes> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/type?attendanceTypeId=${id}`;

    const body = {
      "name": data.name,
      "enabled": data.enabled,
      "entry": data.entry,
      "imputable": data.imputable
    }

    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.patch<any>(url, body, { headers: headers });

  }

  public toggleEnable(id: string, enabled: any): Observable<AppAttendanceTypes> {
    const url = `${AppConfig.settings.apiServerPE.apiUrl}attendance/type?attendanceTypeId=${id}`;

    const body = {
      "enabled": !enabled
    }


    const headers = new HttpHeaders({
      'X-API-KEY': AppConfig.settings.apiServerPE.apiKey
    });

    return this.http.patch<any>(url, body, { headers: headers });

  }


}
